// extracted by mini-css-extract-plugin
export default {"toggle":"tabview_toggle__gP82l","slider":"tabview_slider__WHsOO","toggleContainer":"tabview_toggleContainer__fWbxr"};